export const activityTypeOptions = [
  {
    label: 'Call documents',
    value: 'callDocuments',
  },
  {
    label: 'Person alerts',
    value: 'personAlerts',
  },
  {
    label: 'Person repository',
    value: 'personRepository',
  },
  {
    label: 'Hospital form',
    value: 'hospitalForm',
  },
  {
    label: 'All',
    value: 'all',
  },
];
